import { summaryTableStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsSummaryTable";
import { css } from "styled-components";

Object.assign(summaryTableStyles, {
    orderLines: {
        orderLineCardAddToListGridItem: {
            css: css`
                display: none;
            `,
        },
        orderLineInfoGridItem: {
            width: [12, 12, 12, 8, 8],
            printWidth: 7,
        },
        productInfoGridItem: {
            width: [12, 12, 12, 4, 4],
            printWidth: 5,
        },
        orderLineCardInfoGridItem: {
            width: 10,
        },
        orderLinePriceGridItem: {
            width: 4,
        },
        productInfoTotalsGridItem: {
            width: 6,
        },
        productInfoQtyOrderedGridItem: {
            width: [6, 4, 4, 4, 4],
            css: css`
                @media print {
                    padding-right: 0;
                    padding-left: 0;
                }
            `,
        },
        productInfoQtyShippedGridItem: {
            width: [6, 4, 4, 4, 4],
            css: css`
                @media print {
                    padding-right: 0;
                    padding-left: 5px;
                }
            `,
        },
        productInfoSubtotalGridItem: {
            width: [6, 4, 4, 4, 4],
            css: css`
                @media print {
                    padding-right: 0;
                    padding-left: 5px;
                }
            `,
        },
    },
});
